import { combineReducers } from "redux";
import loginReducer from "./loginReducer";
import errorReducer from "./errorReducer";
import tasksReducer from "./tasksReducer";
import documentReducer from "./documentReducer";
import orderReducer from "./orderReducer";
import appReducer from "./appReducer";
import filtersReducer from "./filtersReducer";
import uploadReducer from "./uploadReducer";
import userReducer from "./userReducer";
import pdfReducer from "./pdfReducer";
import tableReducer from "./tableReducer";
import commandReducer from "./commandReducer";
import letterReducer from "./letterReducer";
// POMUI
import preprocessReducer from "./pomui/preprocessReducer";
import criterionReducer from "./pomui/criterionReducer";
import settingsReducer from "./pomui/settingsReducer";
import filiereReducer from "./pomui/filiereReducer";
import composeReducer from "./pomui/composeReducer";
import channelSettingsReducer from "./pomui/channelSettingsReducer";
import operationReducer from "./pomui/operationReducer";
import sortBatchReducer from "./pomui/sortBatchReducer";
import splitReducer from "./pomui/splitReducer";
import insertReducer from "./pomui/insertReducer";
import csvReducer from "./pomui/csvReducer";

// Combine Reducers
const reducers = combineReducers({
    appState: appReducer,
    loginState: loginReducer,
    errorState: errorReducer,
    tasksState: tasksReducer,
    documentState: documentReducer,
    filtersState: filtersReducer,
    uploadState: uploadReducer,
    userState: userReducer,
    orderState: orderReducer,
    pdfState: pdfReducer,
    tableState: tableReducer,
    commandState: commandReducer,
    letterState: letterReducer,

    //POMUI
    preprocessState: preprocessReducer,
    criterionState: criterionReducer,
    settingsState: settingsReducer,
    filiereState: filiereReducer,
    composeState: composeReducer,
    channelSettingsState: channelSettingsReducer,
    operationState: operationReducer,
    sortBatchState: sortBatchReducer,
    splitState: splitReducer,
    insertState: insertReducer,
    csvState: csvReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js